var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThanks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 128,
    viewBox: "0 0 232 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116 92C126.609 92 136.783 87.7857 144.284 80.2843C151.786 72.7828 156 62.6087 156 52C156 41.3913 151.786 31.2172 144.284 23.7157C136.783 16.2143 126.609 12 116 12C105.391 12 95.2172 16.2143 87.7157 23.7157C80.2143 31.2172 76 41.3913 76 52C76 62.6087 80.2143 72.7828 87.7157 80.2843C95.2172 87.7857 105.391 92 116 92Z",
    fill: "#00B05C",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.179 53.223L114.139 61.3926C118.358 50.6828 121.867 45.9858 129.822 39.6069",
    stroke: "#00B05C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanks);
export default __webpack_public_path__ + "static/media/thanks.cdffb05dfb98f247f370680bb8fcf622.svg";
export { ForwardRef as ReactComponent };